import { REDUCER_NAME } from './const'
import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CREATE_CORRECTION_REQUEST = NS + 'CREATE_CORRECTION_REQUEST'
export const CREATE_CORRECTION_SUCCESS = NS + 'CREATE_CORRECTION_SUCCESS'
export const CREATE_CORRECTION_ERROR = NS + 'CREATE_CORRECTION_ERROR'

export const SHOW_CONFIRMATION_MODAL = NS + 'SHOW_CONFIRMATION_MODAL'
export const CLOSE_CONFIRMATION_MODAL = NS + 'CLOSE_CONFIRMATION_MODAL'



// WEBPACK FOOTER //
// ./src/modules/invoice/state/display/type.js